/**
 * Opens join.stayflexi.com with the current PMS session so the hotelier
 * does not repeat OTP. Join reads #pms_sso in index.html and redirects to
 * /onboarding (WelcomeScreen + saved stepProgress/currentStep from localStorage).
 */
export function getJoinStayflexiBaseUrl() {
  return process.env.REACT_APP_ENV === "BETA"
    ? "https://beta.join.stayflexi.com"
    : "https://beta.join.stayflexi.com";
}

function normalizePmsToken(raw) {
  if (!raw || typeof raw !== "string") return "";
  let t = raw;
  if (t.includes("||master")) t = t.replace(/(\|\|master)+$/, "");
  return t.trim();
}

/**
 * @param {{
 *   email?: string;
 *   token?: string;
 *   search?: string;
 * }} [opts] — defaults from localStorage; `search` e.g. `?utm_source=custompricing`
 */
export function openJoinStayflexiFromPms(opts = {}) {
  const joinBase = getJoinStayflexiBaseUrl().replace(/\/$/, "");
  const email = String(opts.email || localStorage.getItem("HotelEmail") || "")
    .trim()
    .toLowerCase();
  const token = normalizePmsToken(
    opts.token != null ? opts.token : localStorage.getItem("token")
  );

  const pathAndQuery = opts.search
    ? opts.search.startsWith("?")
      ? `/${opts.search}`
      : `/?${opts.search}`
    : "/";

  if (!token || !email) {
    window.open(`${joinBase}${pathAndQuery}`, "_blank");
    return;
  }

  const payload = encodeURIComponent(JSON.stringify({ token, email }));
  window.open(`${joinBase}${pathAndQuery}#pms_sso=${payload}`, "_blank");
}
